import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class PreviousEmploymentDetails extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_previous_employment_details');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'experience_letter')}><i class="fas fa-file-download"></i> Experience Certificate</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'relieving_letter')}><i class="fas fa-file-download"></i> Relieving Letter</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_previous_employment_details';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#previous_employer_name').val(data['previous_employer_name']);
    $('#last_designation').val(data['last_designation']);
    $('#date_of_joining').val(data['date_of_joining']);
    $('#date_of_exit').val(data['date_of_exit']);
    $('#last_drawn_salary').val(data['last_drawn_salary']);

    $('#old_experience_letter').val(data['experience_letter_new_name']);
    $('#old_relieving_letter').val(data['relieving_letter_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF']
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var previous_employer_name    = window.isNullAndUndef($('#previous_employer_name').val());
    var last_designation          = window.isNullAndUndef($('#last_designation').val());
    var date_of_joining           = window.isNullAndUndef($('#date_of_joining').val());
    var date_of_exit              = window.isNullAndUndef($('#date_of_exit').val());
    var last_drawn_salary         = window.isNullAndUndef($('#last_drawn_salary').val());

    var experience_letter_temp    = window.isNullAndUndef($('#experience_letter').val());
    var org_experience_letter     = $("#experience_letter").prop("files")[0];
    var experience_letter_name    = $('#experience_letter').val().split('\\').pop();

    var relieving_letter_temp        = window.isNullAndUndef($('#relieving_letter').val());
    var org_relieving_letter         = $("#relieving_letter").prop("files")[0];
    var relieving_letter_name        = $('#relieving_letter').val().split('\\').pop();


    var experience_letter_ext    = '';
    var relieving_letter_ext  = '';

    if(experience_letter_temp && relieving_letter_temp){
      experience_letter_ext       = experience_letter_temp.split('.').pop();
      relieving_letter_ext        = relieving_letter_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(previous_employer_name && last_designation && date_of_joining && date_of_exit && last_drawn_salary && file_main_ext.indexOf(experience_letter_ext) >= 0 && file_main_ext.indexOf(relieving_letter_ext) >= 0){
      var old_experience_letter                 = $('#old_experience_letter').val();
      var old_relieving_letter                  = $('#old_relieving_letter').val();
      var all_data                              = {};
      all_data['previous_employer_name']        = window.return_false_null(previous_employer_name);
      all_data['last_designation']              = window.return_false_null(last_designation);
      all_data['date_of_joining']               = window.return_false_null(date_of_joining);
      all_data['date_of_exit']                  = window.return_false_null(date_of_exit);
      all_data['last_drawn_salary']             = window.return_false_null(last_drawn_salary);

      all_data['experience_letter']             = window.return_false_null(experience_letter_name);
      all_data['relieving_letter']                 = window.return_false_null(relieving_letter_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('experience_letter',org_experience_letter);
      body.append('relieving_letter',org_relieving_letter);
      body.append('old_experience_letter',old_experience_letter);
      body.append('old_relieving_letter',old_relieving_letter);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_previous_employment_details');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('previous_employer_name','last_designation','date_of_joining','date_of_exit','last_drawn_salary','experience_letter','relieving_letter');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="previous_employer_name" placeholder="Previous Employer Name"/>
                                        <label for="name">Previous Employer Name</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="last_designation" placeholder="Last Designation"/>
                                        <label for="name">Last Designation</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="date_of_joining" placeholder="Date of Joining"/>
                                        <label for="name">Date of Joining</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="date_of_exit" placeholder="Date of Exit"/>
                                        <label for="name">Date of Exit</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="last_drawn_salary" placeholder="Last Drawn Salary"/>
                                        <label for="name">Last Drawn Salary</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_experience_letter" placeholder=""/>
                                        <input type="file" className="form-control" id="experience_letter" placeholder="Experience Certificate"/>
                                        <label for="name">Experience Certificate</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_relieving_letter" placeholder=""/>
                                        <input type="file" className="form-control" id="relieving_letter" placeholder="Relieving Letter"/>
                                        <label for="name">Relieving Letter</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}



                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default PreviousEmploymentDetails;
